// src/pages/caixas/CaixaFechamento.js
import React, { useState, useEffect } from 'react';
import Input from '../../components/input/Input.js';
import { useAlert } from '../../contexts/geral/AlertContext.js';
import { formatDate, formatTime } from '../../utils/dateTimeUtils.js';
import { useCaixaMov } from '../../contexts/caixas/CaixaMovContext.js';
import { formatCurrency, formatNumeric, normalizeDecimalInputBr, parseCurrency } from '../../utils/numberUtils.js';
import { CaixaMov } from '../../models/caixas/CaixaMov.js';
import { useMessage } from '../../contexts/geral/MessageContext.js';
import { useYesNo } from '../../contexts/geral/YesNoContext.js';
import ModalPortal from '../../components/modalForm/ModalPortal';
import { useCaixaResumo } from '../../contexts/caixas/CaixaResumoContext.js';
import { usePrinterCaixa } from '../../contexts/geral/PrinterCaixaContext.js';

const CaixaFechamento = ({ show, onHide, caixa, setCaixa, usuario }) => {
  const { buscaCaixaResumo, caixaResumoSel } = useCaixaResumo();
  const { fecharCaixa } = useCaixaMov();
  const { showAlert } = useAlert();
  const { showMessage } = useMessage();
  const { showYesNo } = useYesNo();
  const [valorFechamento, setValorFechamento] = useState('');
  const { printResumoCaixa } = usePrinterCaixa();  

  useEffect(() => {
    setValorFechamento('');
    if (show) {      
      buscaCaixaResumo(caixa.id);      
    }    
  }, [show]);

  const handleValorFechamentoChange = (value) => {
    setValorFechamento(normalizeDecimalInputBr(value, 2).replace(/-/g, ''));
  };

  const handleValorFechamentoBlur = (value) => {
    setValorFechamento(formatNumeric(parseCurrency(value), 2));
  };

  const handleSave = async () => {
    try {
      const valFechamento = parseCurrency(valorFechamento);
      // if (valFechamento <= 0) {
      //   showMessage('O valor de fechamento deve ser maior que zero!', 'warning');
      //   return;
      // }

      let caixaMov = new CaixaMov();

      caixaMov.caixaId = caixa.id;
      caixaMov.vRec=valFechamento;
      caixaMov.vPag=valFechamento;
      caixaMov.tipoMovCaixa = 3; //Fechamento
      caixaMov.caixaResumoId = caixaResumoSel.id;

      await fecharCaixa(caixaMov);
      caixa.aberto = false;

      showAlert('Caixa fechado com sucesso!', 'success');
      setCaixa({ ...caixa });

      //caixaResumoSel.id

      const resposta = await showYesNo("Deseja imprimir o resumo de caixa?");
      if (resposta) {
        let resumoCaixaId = caixaResumoSel.id;    
        await printResumoCaixa(resumoCaixaId);//Chama função que imprime o resumo do caixa       
      }

      onHide();
    } catch (error) {
      console.error('Erro ao fechar caixa:', error);
      showMessage('Erro ao fechar caixa! '+  error, 'danger');
    }
};



  if (!show) return null;

  return (
    <ModalPortal show={show}>
    <div className="modal d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog" role="document" style={{ maxWidth: '500px' }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Fechamento de Caixa</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
          </div>

          <div className="modal-body">
            <div className="input-group">
              <Input label="Usuário" value={`${usuario?.id} - ${usuario?.nome}`} disabled={true} size={200} />
              <Input label="Caixa" value={`${caixa?.id} - ${caixa?.descricao}`} disabled={true} size={200} />
            </div>

            <div className="input-group">
              <Input label="Abertura" value={formatDate(caixaResumoSel?.abertura)+" - "+formatTime(caixaResumoSel?.abertura)} disabled={true} size={200} />
              <Input label="Valor Abertura" value={formatCurrency(caixaResumoSel?.valorAbertura)} disabled={true} size={100} />
            </div>

            <div className="input-group">
              <Input label="Entradas" value={formatCurrency(caixaResumoSel?.valorEntrada)} disabled={true} size={100} />
              <Input label="Saídas" value={formatCurrency(caixaResumoSel?.valorSaida)} disabled={true} size={100} />
            </div>

            <div className="input-group">
              <Input
                label="Saldo Final"
                value={valorFechamento}
                onChange={(e) => handleValorFechamentoChange(e.target.value)}
                onBlur={(e) => handleValorFechamentoBlur(e.target.value)}
                size={100}
                autoFocus
                style={{
                  textAlign: 'right',
                  width: '100px',
                  marginRight: '10px',
                  fontSize: '1.2em',
                  fontWeight: 'bold',
                  color: 'red',
                  border: '1px solid red',
                  borderRadius: '5px',
                  padding: '5px',
                  backgroundColor: 'lightcoral',
                }}
              />
            </div>
          </div>

          <div className="modal-footer" style={{ gap: '10px' }}>
            <button type="button" className="btn btn-secondary" onClick={onHide}>
              Cancelar
            </button>
            <button type="button" className="btn btn-primary" onClick={handleSave}>
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};

export default CaixaFechamento;
